<template lang="pug">
div(ref="root")
  span(
    v-if="truncate"
    :key="1"
    :truncate="truncate"
    ref="spanToTruncate")
    slot
  span(
    v-else
    :key="2"
    :truncate="!truncate"
    ref="span")
    slot
  div.text-center(v-if="hasTruncated")
    v-btn(
      @click="truncate = !truncate"
      text
      small) {{ truncate ? 'Voir plus' : 'Voir moins' }}
</template>

<script>
import clamp from 'clamp-js'
import { ref, onMounted, watch, reactive, toRefs } from '@vue/composition-api'
import { vuetify } from '@iez/core'
import Vue from 'vue'

export default {
  props: {
    lineCount: Number
  },

  setup () {
    const spanToTruncate = ref(null)
    const span = ref(null)
    const root = ref(null)
    const state = reactive({
      truncate: true,
      hasTruncated: false
    })

    watch(
      () => state.truncate,
      truncate => {
        if (truncate) {
          Vue.nextTick(() => {
            let height = spanToTruncate.value.offsetHeight
            clamp(spanToTruncate.value, { clamp: 5 })
            state.hasTruncated = height > spanToTruncate.value.offsetHeight
          })
        } else {
          /* Vue.nextTick(() => {
            vuetify.framework.goTo(root.value)
          }) */
        }
      }, {
        immediate: true
      }
    )

    return {
      spanToTruncate,
      span,
      root,
      ...toRefs(state)
    }
  }
}
</script>
